import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { ControlContainer, NgForm } from '@angular/forms';


@Component({
    selector: 'service-identification',
    templateUrl: './service-identification.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class ServiceIdentificationComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.ServiceIdentificationVM = {} as models.ServiceIdentificationVM;
  public cardConfiguration: models.CardVM;

  //@CommonData(DomainCodes.domains)
  //public domains: models.DimensionVM[];
  //@CommonData(DomainCodes.country)
  //public countries: models.DimensionVM[];

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
}
